export default "/images/7e6f93b9c870a7a4f83468a976f4cb60.avif";